@if (active) {
  <div>
    @if (!this.enableDeactivateDate) {
      <div>
        <button class="btn btn-secondary" (click)="showDeactivateDate($event)">Deactivate</button>
      </div>
    }
    @if (this.enableDeactivateDate) {
      <div class="deactivate-date-edit bg-light p-3">
        @if (this.showDeactivateDateIsRequiredMessage) {
          <div class="text-danger">
            Please enter a date before saving.
          </div>
        }
        <input type="date" name="deactivateDate" [(ngModel)]="deactivateDate" />
        <div>
          <a class="text-primary" href="#" (click)="saveDeactivateDate($event)">Save</a>
          <a class="ps-2" href="#" (click)="hideDeactivateDate($event)">Cancel</a>
        </div>
      </div>
    }
  </div>
}
